module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primærlogo_sentrert_logo_pos.f1e5ff8b.svg";